import { SnackbarOrigin } from '@mui/material';

import { colors, fonts, radius, sizes } from '../../theme';

const SUCCESS = '#34C759';

const styles = {
  // Top right: seen at once, far from the video and its actions.
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  } as SnackbarOrigin,
  snackbar: {
    top: `${sizes.gutter}px !important`,
    right: `${sizes.gutter}px !important`,
  },
  // Like the toasts of the app: a dark card, the color in the icon and in a bar on the left.
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    minWidth: 280,
    maxWidth: 400,
    px: 1.75,
    py: 1.5,
    borderRadius: radius.card,
    border: `1px solid ${colors.border}`,
    borderLeftWidth: 4,
    backgroundColor: colors.surface,
    boxShadow: '0 12px 32px rgba(0, 0, 0, 0.6)',
    fontFamily: fonts.text,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: 1.4,
    color: colors.text,
  },
  accents: {
    success: { borderLeftColor: SUCCESS },
    warning: { borderLeftColor: colors.warning },
    error: { borderLeftColor: colors.danger },
  },
  icon: {
    width: 24,
    height: 24,
    flexShrink: 0,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#000000',
    fontSize: 13,
    fontWeight: 800,
  },
  icons: {
    success: { backgroundColor: SUCCESS },
    warning: { backgroundColor: colors.warning },
    error: { backgroundColor: colors.danger, color: '#FFFFFF' },
  },
};

export default styles;
